import { useEffect, useState } from "react";
import { getTotalSummary } from "../services/studentService";
import { StudentTotalSummary } from "../types";

export const useStudentTotalSummary = () => {
  const [summary, setSummary] = useState<StudentTotalSummary | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const data = await getTotalSummary();
        setSummary(data);
      } catch (err) {
        setError("Failed to load student summary.");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  return { summary, loading, error };
};
